import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Checkbox, Flex, FlexItem, Select } from 'mailup-web-components'

import {
  modalBulkAddToGroupChangeCallback,
  modalBulkAddToGroupToggleOptRemoveFromGroupsCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalBulkAddToGroup'
import { modalBulkAddToGroupState } from 'Pages/RecipientsList/recoil/state/modals'

const InputRemoveFromGroups: FC = () => {
  const intl = useIntl()

  const { optRemoveFromGroups, removeFromGroupsMode, searchGroups } =
    useRecoilValue(modalBulkAddToGroupState)

  const toggleOptRemoveFromGroups = useRecoilCallback(
    modalBulkAddToGroupToggleOptRemoveFromGroupsCallback,
    [],
  )

  const modalStateChange = useRecoilCallback(
    modalBulkAddToGroupChangeCallback,
    [],
  )

  const options = [
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.OptRemoveFromBelongingGroups',
      }),
      value: 'all',
    },
    {
      label: intl.formatMessage({
        id: 'Load.RecipientsList.OptRemoveFromSearchGroups',
      }),
      value: 'search',
    },
  ]

  const handleChange = (v: 'all' | 'search'): void => {
    void modalStateChange({ removeFromGroupsMode: v })
  }

  return (
    <Flex alignItems="center" gap="8px">
      {searchGroups.length > 0 ? (
        <>
          <Checkbox
            checked={optRemoveFromGroups}
            data-mu-test="opt-remove-from-groups"
            label={intl.formatMessage({
              id: 'Load.RecipientsList.RemoveFromGroups',
            })}
            onChange={toggleOptRemoveFromGroups}
          />
          <FlexItem alignItems="center" flexGrow={1}>
            <Select
              value={removeFromGroupsMode}
              options={options}
              data-mu-test="remove-from-gropus-mode"
              searchable={false}
              onChange={handleChange}
            />
          </FlexItem>
        </>
      ) : (
        <Checkbox
          checked={optRemoveFromGroups}
          data-mu-test="opt-remove-from-groups"
          label={intl.formatMessage({
            id: 'Load.RecipientsList.RemoveFromBelongingGroups',
          })}
          onChange={toggleOptRemoveFromGroups}
        />
      )}
    </Flex>
  )
}

export default InputRemoveFromGroups
